import annualReportCover from "@images/investor-relations/resources/annual-report.webp";
import companyProfileCover from "@images/investor-relations/resources/company-profile.webp";
import investorKitCover from "@images/investor-relations/resources/investor-kit.webp";
import { getCurrentLocaleCode } from "@mongez/localization";

/**
 * Investor Resources — Section 08 of the approved IR content sheet.
 * Exactly three resources, each with a cover, a View action and a Download action.
 */

/**
 * A document that is either one file serving both locales, or one file per
 * locale. The content sheet asks for Arabic and English versions of all three
 * resources, but only the Annual Report was delivered as a pair.
 *
 * TODO: replace the single-file entries once Arabic editions of the Investor
 * Kit and the Company Profile are supplied.
 */
export type ResourceFile = string | { en: string; ar: string };

export type InvestorResource = {
  key: string;
  /** Translation key for the resource title. */
  title: string;
  /** Translation key for the `PDF · <period>` meta line. */
  meta: string;
  cover: string;
  file: ResourceFile;
};

/** Picks the current locale's edition, falling back to the English one. */
export function resolveResourceFile(file: ResourceFile): string {
  if (typeof file === "string") return file;

  return file[getCurrentLocaleCode() as keyof typeof file] ?? file.en;
}

export const investorResources: InvestorResource[] = [
  {
    key: "investorKit",
    title: "investorResources.items.investorKit.title",
    meta: "investorResources.items.investorKit.meta",
    cover: investorKitCover,
    // Served from `public/` rather than imported — at 88MB it has no business
    // going through the client bundle.
    file: "/pdf/senaat-investor-kit.pdf",
  },
  {
    key: "annualReport",
    title: "investorResources.items.annualReport.title",
    meta: "investorResources.items.annualReport.meta",
    cover: annualReportCover,
    // Already hosted, and already used by `InvestorReport`.
    file: {
      en: "https://apps.crafted-internet.com/senaat/en/pdf/SENAAT_Report_2025_English_Final_ Submission.pdf",
      ar: "https://apps.crafted-internet.com/senaat/ar/pdf/SENAAT_Report_2025_Arabic_Final_Submission.pdf",
    },
  },
  {
    key: "companyProfile",
    title: "investorResources.items.companyProfile.title",
    meta: "investorResources.items.companyProfile.meta",
    cover: companyProfileCover,
    file: "/pdf/senaat-company-profile.pdf",
  },
];
